"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_circular_progressbar_1 = require("react-circular-progressbar");
require("react-circular-progressbar/dist/styles.css");
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var eventHelper_1 = __importDefault(require("../../shared/utilities/eventHelper"));
function RadialProgress(props) {
    var _a;
    var defaultClass = "CircularProgressbar";
    return (react_1.default.createElement("div", __assign({}, (0, eventHelper_1.default)(props.callback), { role: "status", className: (0, classMap_1.default)("mpng-ux-radial-progress", props.className, props.callback ? "cursor-pointer" : ""), tabIndex: props.callback ? 0 : undefined }),
        react_1.default.createElement(react_circular_progressbar_1.CircularProgressbarWithChildren, __assign({}, props, { styles: (0, react_circular_progressbar_1.buildStyles)(__assign({}, props.styles)),
            circleRatio: (_a = props.circleRatio) !== null && _a !== void 0 ? _a : 0.7,
            classes: {
                root: (0, classMap_1.default)(defaultClass),
                trail: (0, classMap_1.default)("".concat(defaultClass, "-trail"), "stroke stroke-".concat(props.trailColor)),
                path: (0, classMap_1.default)("".concat(defaultClass, "-path"), "stroke stroke-".concat(props.pathColor)),
                text: (0, classMap_1.default)("".concat(defaultClass, "-text")),
                background: (0, classMap_1.default)("".concat(defaultClass, "-background"))
            } }), props.items)));
}
exports.default = RadialProgress;
